import React from 'react';

import styled from 'styled-components';

import { Navbar, MainPageContainer } from 'components-core';

const PlugContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftPlug = styled.span`
  display: inline-block;
  height: 100px;
  width: 688px;
  background-image: url(${require('../../assets/images/maintenance-left@3x.png')});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0 0;

  @media screen and (min-width: 320px) {
    background-position: -610px -10px;
  }

  @media screen and (min-width: 360px) {
    background-position: -590px -10px;
  }

  @media screen and (min-width: 768px) {
    background-position: -410px -10px;
  }

  @media screen and (min-width: 971px) {
    height: 100px;
    background-position: -300px -10px;
  }

  @media screen and (min-width: 1024px) {
    height: 100px;
    background-position: -300px 0;
  }

  @media screen and (min-width: 1365px) {
    width: 688px;
    background-position: -160px 0;
  }

  @media screen and (min-width: 1700px) {
    background-position: 0 0;
    height: 100px;
    width: 764px;
  }
`;

const RightPlug = styled.span`
  display: inline-block;
  height: 100px;
  width: 688px;
  background-image: url(${require('../../assets/images/maintenance-right@3x.png')});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0 0;

  @media screen and (min-width: 320px) {
    background-position: 20px -10px;
  }

  @media screen and (min-width: 360px) {
    background-position: 20px -10px;
  }

  @media screen and (min-width: 1024px) {
    background-position: 90px 0;
  }

  @media screen and (min-width: 1366px) {
    width: 688px;
  }

  @media screen and (min-width: 1700px) {
    background-position: 0 0;
    height: 100px;
    width: 764px;
  }
`;

const Wrapper = styled.div`
  padding: 0 24px;
  margin: 0 auto;
  margin-top: 48px;
  max-width: 544px;
`;

const MaintenanceTitle = styled.h1`
  font-size: 38px;
  line-height: 44px;
  text-align: center;
  margin: 0;

  @media screen and (max-width: 991px) {
    font-size: 26px;
    line-height: 34px;
  }
`;

const MaintenanceText = styled.p`
  margin: 0 auto;
  margin-top: 24px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  font-weight: 300;
  max-width: 416px;

  @media screen and (max-width: 991px) {
  }
`;

const Email = styled.a`
  text-decoration: none;
  color: #9000ff;
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const Maintenance = () => {
  return (
    <MainPageContainer height="100%">
      <Navbar hideCloseIcon />
      <MainWrapper>
        <PlugContainer>
          <LeftPlug />
          <RightPlug />
        </PlugContainer>
        <Wrapper>
          <MaintenanceTitle>Estamos trabalhando para melhorar nosso sistema.</MaintenanceTitle>
          <MaintenanceText>
            O site ficará indisponível algumas horas, mas, você pode entrar em contato pelo e-mail
            <span>
              <Email href="mailto:equipe@juntoseguros.com"> equipe@juntoseguros.com</Email>
            </span>
          </MaintenanceText>
        </Wrapper>
      </MainWrapper>
    </MainPageContainer>
  );
};

export default Maintenance;
